import { UserPermissions } from '@enums/user-permissions';
import { Cursor } from '@pages/home-page/types';

export type LabelItem = {
  id: number;
  name: string;
  clientId?: number;
  userId?: number;
  metadata?: Record<string, unknown>;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  parentId?: number;
};

export type LabelList = Record<string, LabelItem>;

export type Label = {
  id: number;
  name: string;
  parentId?: number;
};

export type LabelModalData = {
  name?: string;
  metadata?: any;
};

export enum ContentModalActionType {
  CREATE_LABEL = 'createLabel',
  EDIT_LABEL = 'editLabel',
  LABEL_METADATA = 'labelMetadata',
  DELETE_LABEL = 'deleteLabel',
}

export enum LabelActions {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
}

export type LabelsResponseType = {
  items: LabelItem[];
  cursor?: Cursor;
};

export type MoreActionItemType = {
  action: ContentModalActionType;
  label: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  permission?: UserPermissions;
};
